import type { LatLng } from '@kick/types';

/**
 * Distancia en metros entre dos puntos (haversine).
 *
 * Es una aproximación: el servidor mide con PostGIS sobre el elipsoide y es
 * quien decide lo que se cobra. Aquí solo se usa para mostrar cuánto le falta
 * al domiciliario, donde unos metros de diferencia no cambian nada.
 */
export function distanciaMetros(a: LatLng, b: LatLng): number {
  const R = 6_371_000;
  const rad = (g: number): number => (g * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h =
    Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return Math.round(2 * R * Math.asin(Math.sqrt(h)));
}
